import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useAluno } from "@/hooks/alunos";
import { Button } from "@/components/Common";

import api, { makeOptions } from "@/services/api";
import toastify from "@/services/toastify";

import { ModalContent, ModalFooter } from "./styles";

export default function ModalDeleteFormacaoAnterior({ onClose, id }) {
  const { data: user } = useSelector(state => state.auth);
  const [loading, setLoading] = useState(false);
  const { aluno, fetchAluno } = useAluno();

  async function deleteFormacaoAnterior() {
    setLoading(true);
    const endpoint = `alunos/curriculos/formacoes-anteriores/${id}`;
    const alunoId = aluno.id;
    const { data: response } = await api.delete(
      endpoint,
      makeOptions(user)
    );
    setLoading(false);
    if (response.success) {
      toastify("Formação removida com sucesso");
      fetchAluno(alunoId);
      onClose();
    }
  }

  return (
    <ModalContent>
      <h2>Remover esta formação?</h2>
      <ModalFooter>
        <Button variant="cancel" onClick={() => onClose()}>
          Cancelar
        </Button>
        <Button
          variant="tangerine"
          onClick={deleteFormacaoAnterior}
          loading={loading || undefined}
        >
          Remover
        </Button>
      </ModalFooter>
    </ModalContent>
  );
}
